<template>
  <div class="container">
    <b-modal
      :model-value="modalVisible"
      :no-close-on-backdrop="true"
      hide-footer
      hide-header-close
      centered
      :title="labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog"
    >
      <div class="uniform-modal-body">
        <div class="password-policy-box mb-3">
          <div class="password-policy-title">{{ labels.formInfoTitle }}</div>
          <div class="password-policy-item">{{ labels.formInfoSubtitle }}</div>
        </div>

        <b-col md="4" lg="12" class="p-0 mx-auto">
          <b-form-group @submit.prevent="guardaInfoUser">
            <label>{{ labels.name }}</label>
            <b-form-input v-model="form.nombre" type="text" class="reset-input" autocomplete="off"></b-form-input><br>
            <label>{{ labels.identificationCard }}</label>
            <b-form-input v-model="form.cedula" type="text" class="reset-input" autocomplete="off"></b-form-input><br>
            <label>{{ labels.email }}</label>
            <b-form-input v-model="form.email" type="email" class="reset-input" autocomplete="new-password" name="user_email"></b-form-input><br>
            <label>{{ labels.phone }}</label>
            <b-form-input v-model="form.telefono" type="text" class="reset-input" autocomplete="off"></b-form-input><br>
            <label>{{ labels.role }}</label>
            <b-form-select v-model="rolSelected" class="reset-input" autocomplete="off">
              <option value="" disabled>{{ labels.role }}</option>
              <option v-for="item in roles" :key="item?.id" :value="item?.id">{{ item?.nombre }}</option>
            </b-form-select><br>
            <label>{{ labels.passw }}</label>
            <b-form-input v-model="form.password" type="password" class="reset-input" autocomplete="new-password" name="user_password"></b-form-input><br>
          </b-form-group>
          <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
            <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">{{ labels.close }}</b-button>
            <b-button class="reset-btn-primary" @click="guardaInfoUser()">{{ labels.save }}</b-button>
          </div>
        </b-col>
      </div>
    </b-modal>
  </div>
</template>

<script>
import User from "@/services/User";
import Rol from "@/services/Roles";

export default {
  name: "CreateUser",
  props: {
    showDialogCreate: {
      type: Boolean,
      default: null
    }
  },
  data: () => ({
    form: {
      nombre: "",
      cedula: "",
      email: "",
      telefono: "",
      password: "",
      state: "1",
      id_tipo_user: "1"
    },
    roles: [],
    rolSelected: "",
    isLoading: false
  }),
  computed: {
    modalVisible() {
      if (typeof this.showDialogCreate === "boolean") return this.showDialogCreate
      return true
    },
    hasExternalControl() {
      return typeof this.showDialogCreate === "boolean"
    },
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Crear usuario",
          save: "Guardar",
          close: "Cerrar",
          name: "Nombre",
          identificationCard: "Cedula",
          email: "Correo",
          phone: "Teléfono",
          role: "Rol",
          passw: "Password",
          formInfoTitle: "Datos del usuario",
          formInfoSubtitle: "Completa la información y guarda el nuevo usuario."
        }
      }
      return {
        title: "Create user",
        save: "Save",
        close: "Close",
        name: "Name",
        identificationCard: "Identification card",
        email: "Email",
        phone: "Phone",
        role: "Role",
        passw: "Password",
        formInfoTitle: "User information",
        formInfoSubtitle: "Complete the information and save the new user."
      }
    }
  },
  methods: {
    closeModal() {
      if (this.hasExternalControl) {
        this.$emit("closeModal", false)
        return
      }

      this.$router.push({ path: "/users" })
    },
    resetForm() {
      this.form = {
        nombre: "",
        cedula: "",
        email: "",
        telefono: "",
        password: "",
        state: "1",
        id_tipo_user: "1"
      }
      this.rolSelected = ""
    },
    guardaInfoUser() {
      if (!this.form.nombre) {
        this.$toast.error("Diligenciar el nombre")
        return
      }
      if (!this.form.email) {
        this.$toast.error("Diligenciar el correo")
        return
      }
      if (!this.form.password) {
        this.$toast.error("Diligenciar la contraseña")
        return
      }
      if (!this.rolSelected) {
        this.$toast.error("Diligenciar el rol")
        return
      }

      const infoForm = {
        ...this.form,
        id_rol: this.rolSelected
      }

      User.createUser(infoForm)
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            this.$toast.success("Usuario creado correctamente")
            this.resetForm()
            this.$emit("created")
            this.closeModal()
          }
        })
        .catch((error) => {
          console.log(error)
          this.$toast.error("No se pudo crear el usuario")
        })
    }
  },
  mounted() {
    Rol.getAllRoles()
      .then((rta) => {
        this.roles = rta.data.roles
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>
